/** Add this function to the default case of a switch statement,
 * hand over the switched-on variable and it will raise a compiler error of not all cases are covered  */
export function assertExhaustiveSwitch(x: never): never {
  throw new Error("switch not exhaustive");
}
